import React from 'react';

import {
  Container,
  Title,
  Label,
  TextInput,
  Button,
  TextLink,
  LinkButton,
  Form,
} from 'ui/components/styled';
import { Logo } from 'ui/components/shared';
import { AuthLayout } from 'ui/components/layouts';
import { useUser, useToasts, useLayout } from 'hooks';
import useMediaQuery from 'hooks/useMediaQuery';
import device from 'ui/theme/device';

export const SignIn = () => {
  const [state, setState] = React.useState({ email: '', password: '' });
  const { setLayoutLoading } = useLayout();
  const { isLoggedIn, fetchUser, signIn, redirectToDashboard } = useUser();
  const { errorToast } = useToasts();
  const isSmall = useMediaQuery(device.small);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const success = await signIn(state.email, state.password, true);
      if (success) {
        const user = await fetchUser(false);
        if (user) {
          redirectToDashboard();
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Sign In' });
    }
    setLayoutLoading(false);
  };
  // console.log(isLarge);
  return (
    <AuthLayout show={!isLoggedIn}>
      <Container width="80%" maxWidth="480px" height="auto">
        <Logo mb="m" />
        <Title mb="m">Hi, Welcome</Title>
        <Form onSubmit={handleSubmit}>
          <Container mb="m">
            <Label htmlFor="email" mb="xs">
              Email address
            </Label>
            <TextInput
              id="email"
              name="email"
              type="email"
              placeholder="Email"
              value={state.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </Container>
          <Container mb="m">
            <Label htmlFor="pwd" mb="xs">
              Password
            </Label>
            <TextInput
              id="pwd"
              name="password"
              type="password"
              placeholder="Password"
              value={state.password}
              onChange={handleChange}
              required
            />
          </Container>
          <Container flexDirection={isSmall ? 'column' : 'row'} my="m">
            <LinkButton to="/sign-up" variant="secondary" mr="l" my={isSmall && 'm'}>
              Register
            </LinkButton>
            <Button type="submit">Log in</Button>
          </Container>
        </Form>
        <TextLink to="/forgot-password" mt="m">
          Forgot password?
        </TextLink>
      </Container>
    </AuthLayout>
  );
};
